import React from 'react';
import Loader from 'react-loader-spinner';

const loaderConfig = {
  type: 'ThreeDots',
  height: 15,
  width: 15,
  color: '#fff'
};

export default function ActionButton(props) {
  return (
    <button
      onClick={props.onClick}
      className={`button action${props.negative ? ' negative' : ''}${
        props.cls ? ` ${props.cls}` : ''
      }`}
      style={props.style}
      disabled={props.disabled}
    >
      {props.loading ? <Loader {...loaderConfig} /> : props.text}
    </button>
  );
}

ActionButton.defaultProps = {
  cls: '',
  disabled: false,
  loading: false,
  negative: false,
  style: {},
  text: 'Basic'
};
